module.exports = __webpack_public_path__ + "static/media/service-icon-01.8cedabe6.gif";